// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cms__color__picker.color-highlight .ant-popover-inner {
  height: 40px !important;
  padding: 0 !important;
  min-width: unset !important;
}

.cms__color__picker.color-highlight .ant-popover-inner .ant-collapse-header {
  display: none !important;
}

.ant-color-picker-trigger.cms__color__picker.color-highlight {
  min-width: 20px !important;
  min-height: 20px !important;
}

.ant-color-picker-trigger.cms__color__picker.color-highlight .ant-color-picker-color-block {
  width: 16px !important;
  height: 16px !important;
}
`, "",{"version":3,"sources":["webpack://./../editor/src/components/Buttons/TextHighlightButton.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB","sourcesContent":[".cms__color__picker.color-highlight .ant-popover-inner {\n  height: 40px !important;\n  padding: 0 !important;\n  min-width: unset !important;\n}\n\n.cms__color__picker.color-highlight .ant-popover-inner .ant-collapse-header {\n  display: none !important;\n}\n\n.ant-color-picker-trigger.cms__color__picker.color-highlight {\n  min-width: 20px !important;\n  min-height: 20px !important;\n}\n\n.ant-color-picker-trigger.cms__color__picker.color-highlight .ant-color-picker-color-block {\n  width: 16px !important;\n  height: 16px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
